// Mark the document when the signed-in account is internal so the shell
// can show platform ops links (Items, Jobs, Pipelines, …) only to those
// accounts. Members keep YogaKai’s own links (Today, Library, Teach, Membership, Profile).
import { onAuthChanged, getClaims } from '../data/authPlane';

function setInternalFlag(on) {
  if (typeof document === 'undefined') return;
  if (on) document.documentElement.dataset.internal = 'true';
  else delete document.documentElement.dataset.internal;
}

export function syncInternalNav() {
  if (typeof document === 'undefined') return () => {};
  setInternalFlag(false);
  return onAuthChanged(async (user) => {
    if (!user) {
      setInternalFlag(false);
      return;
    }
    try {
      const claims = await getClaims();
      setInternalFlag(claims.internal === true);
    } catch {
      setInternalFlag(false);
    }
  });
}
